import { Download } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import React, { useRef, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { pdfjs } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PdfViewerModal = ({ pdfUrl, isOpen, handleCloseModal, download }) => {
  const pdfContainerRef = useRef(null);
  const [scale, setScale] = useState(1);
  const [isPdfData, setIsPdfData] = useState(false);

  useEffect(() => {
    const renderPdfToContainer = async () => {
      try {
        const pdf = await pdfjs.getDocument(pdfUrl).promise;
        const numPages = pdf.numPages;
        if (pdf) {
          setIsPdfData(true);
        }
        for (let pageNum = 1; pageNum <= numPages; pageNum++) {
          const page = await pdf.getPage(pageNum);
          const viewport = page.getViewport({ scale: 1 });

          // const screenHeight = window.innerHeight;
          // const newScale = screenHeight / viewport.height;
          // setScale(newScale);
          const newScale = scale;
          const canvas = document.createElement("canvas");
          canvas.height = viewport.height * newScale;
          canvas.width = viewport.width * newScale;
          const context = canvas.getContext("2d");

          const renderContext = {
            canvasContext: context,
            viewport: page.getViewport({ scale: newScale }),
          };

          await page.render(renderContext);
          pdfContainerRef.current.appendChild(canvas);
        }
      } catch (error) {
        console.error("Error rendering PDF:", error);
      }
    };

    renderPdfToContainer();
  }, [pdfUrl]);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "terms.pdf"; // You can customize the filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <>
      <Modal show={isOpen} size="lg" onHide={handleCloseModal} centered>
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isPdfData ? (
            <>
              {download && (
                <div className="download-pdf" onClick={handleDownload}>
                  <span>Download</span>
                  <Download style={{ fontSize: "16px" }} />
                </div>
              )}
              <div className="scrollable-pdf-viewer">
                <div
                  className="table-scrollY"
                  style={{
                    maxHeight: "500px",
                    overflowY: "auto",
                  }}
                >
                  <div
                    ref={pdfContainerRef}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      transform: `scale(${scale})`,
                      transformOrigin: "top",
                    }}
                  />
                </div>
              </div>
            </>
          ) : (
            <div className="text-center" style={{ maxHeight: "500px" }}>
              <CircularProgress />
            </div>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PdfViewerModal;
